module.exports = __webpack_public_path__ + "static/media/wallpaper-light.46db67b4.jpg";